import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceEndpointsService {

  constructor(public rest: RestService ) { }

  public getServiceEndpoints() {
      let username = localStorage.getItem("username");
        return this.rest.post('getServiceEndpoints', username);
    }

}
